import {
    ObjectPropertyType,
    ObjectValidatorInterface,
    SimplePropertyType,
    ValidatorInterface,
    ValidationErrorType,
} from "commons/types/validation";

export const getExtraErrorsDescription = (code: string): string => {
    const mapping: { [x: string]: string } = {
        emptyFile: "File non presente",
        fileTooBig: "Il file è troppo grande",
        invalidUrl: "URL non valido",
        descriptionTooLong: "La descrizione non può superare 100 caratteri",
    };

    if (code in mapping) {
        return mapping[code];
    }

    return code;
};

export const maxLength100Validator: ValidatorInterface = ({ value, path }) => {
    const errors: Array<ValidationErrorType> = [];

    if (value) {
        const text = (value as string).replace(/<[^>]*>/g, "").trim();
        if (text.length > 100) {
            errors.push({ path, code: "descriptionTooLong" });
        }
    }

    return errors;
};

export const urlValidator: ValidatorInterface = ({ value, path }) => {
    const errors: Array<ValidationErrorType> = [];

    if (value && (value as string).trim() !== "") {
        try {
            new URL(value as string);
        } catch {
            errors.push({ path, code: "invalidUrl" });
        }
    }

    return errors;
};

export const imageSizeValidator: ObjectValidatorInterface = ({ object, path }) => {
    const errors: Array<ValidationErrorType> = [];

    if (
        object &&
        (object.status === 0 || object.status === 1) &&
        object.size &&
        object.size > 1048576 // 1Mb
    ) {
        errors.push({
            path,
            code: "fileTooBig",
        });
    }

    return errors;
};

export const fileSizeValidator: ObjectValidatorInterface = ({ object, path }) => {
    const errors: Array<ValidationErrorType> = [];

    // 160 Mb
    if (object.size && object.size > 167772160) {
        errors.push({
            path,
            code: "fileTooBig",
        });
    }

    return errors;
};

export const fileNotEmptyValidator: ObjectValidatorInterface = ({
    object,
    path,
}): Array<ValidationErrorType> => {
    const errors: Array<ValidationErrorType> = [];

    if (object && (object.status === 0 || object.status === 1) && object.content.trim() === "") {
        errors.push({
            path: path,
            code: "emptyFile",
        });
    }

    return errors;
};

export const fileProperties: { [x: string]: SimplePropertyType } = {
    id: {
        type: "simple",
        validators: [],
    },
    label: {
        type: "simple",
        validators: [],
    },
    filename: {
        type: "simple",
        validators: [],
    },
    file_content: {
        type: "simple",
        validators: [],
    },
    content_type: {
        type: "simple",
        validators: [],
    },
    status: {
        type: "simple",
        validators: [],
    },
    size: {
        type: "simple",
        validators: [],
    },
};

export const fileWithValidation: ObjectPropertyType = {
    type: "object",
    validators: [fileSizeValidator],
    properties: fileProperties,
};

export const imageNotEmpty: ObjectPropertyType = {
    type: "object",
    validators: [fileNotEmptyValidator, imageSizeValidator],
    properties: fileProperties,
};

export const fileSchema: ObjectPropertyType = {
    type: "object",
    validators: [imageSizeValidator],
    properties: fileProperties,
};

export const notEmptyMedia: ObjectPropertyType = {
    type: "object",
    validators: [],
    properties: {
        id: {
            type: "simple",
            validators: [],
        },
        desktop_id: {
            type: "simple",
            validators: [],
        },
        mobile_id: {
            type: "simple",
            validators: [],
        },
        desktop: imageNotEmpty,
        mobile: imageNotEmpty,
    },
};

export const possibleEmptyMedia: ObjectPropertyType = {
    type: "object",
    validators: [],
    properties: {
        id: {
            type: "simple",
            validators: [],
        },
        desktop_id: {
            type: "simple",
            validators: [],
        },
        mobile_id: {
            type: "simple",
            validators: [],
        },
        desktop: fileSchema,
        mobile: fileSchema,
    },
};
